import Modal from "../Modal/Modal";
import React, { useCallback, useState } from "react";
import { IUser } from '../../helpers/Interfaces';
import { separateRoles } from "../../helpers/HelperFunctions";
import FileProgress from "../FileProgress/FileProgress";

import "./ViewUserModal.scss"

function ViewUserModal(props: { open: boolean; close: CallableFunction, selectedUser: IUser; openEdit: CallableFunction; }) {

    const [showAlert, setShowAlert] = useState({ isError: false, message: "", open: false });

    const closeAlert = () => {
        let newShowAlert = showAlert;
        newShowAlert.open = false;
        setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
    }

    const handleClose = useCallback(() => {
        props.close("view");
    }, [])

    return (
        <Modal showAlert={showAlert} closeAlert={closeAlert} open={props.open} close={handleClose}
            style={"view-user-card"}>
            <div className="view-user-modal-container">
                <FileProgress name={props.selectedUser.firstName + " " + props.selectedUser.lastName} imageUrl={props.selectedUser.profileImageUrl} style={"profile-size"} />
                <span className="user-role">{separateRoles(props.selectedUser.roles)}</span>
                <span className="user-name">{props.selectedUser.firstName + " " + props.selectedUser.lastName}</span>
                <span className="user-email">{props.selectedUser.email}</span>
            </div>
        </Modal>
    )
}

export default ViewUserModal